import { MessageOutlined, SmileOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { TabDefinition } from '../../../shared/components/Tab/Tabs';
import { Space } from 'antd';
import { Transcript } from '../Transcript';
import { Comments } from '../Comments';
import { Reactions } from '../Reactions';

export const commentsTab: TabDefinition = {
  children: <Comments />,
  key: 'comments',
  label: (
    <Space>
      <MessageOutlined style={{ fontSize: '16px' }} />
      Comments
    </Space>
  ),
};

export const transcriptTab: TabDefinition = {
  children: <Transcript />,
  key: 'transcript',
  label: (
    <Space>
      <VideoCameraOutlined style={{ fontSize: '16px' }} />
      Video transcript
    </Space>
  ),
};

export const reactionsTab: TabDefinition = {
  children: <Reactions />,
  key: 'reactions',
  label: (
    <Space>
      <SmileOutlined style={{ fontSize: '16px' }} />
      Reactions
    </Space>
  ),
};
